import { render, staticRenderFns } from "./ItineraryForm.vue?vue&type=template&id=2a3a7642&scoped=true&"
import script from "./ItineraryForm.vue?vue&type=script&lang=js&"
export * from "./ItineraryForm.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryForm.vue?vue&type=style&index=0&id=2a3a7642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a7642",
  null
  
)

export default component.exports